import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../../services/config/config.service';
import { FleteService } from '../../../services/flete/flete.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-rango-proveedor',
  templateUrl: './rango-proveedor.component.html',
  styleUrl: './rango-proveedor.component.scss',
  standalone: false,
  providers: [MessageService]
})
export class RangoProveedorComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  token: any = {};
  infoEmpresa: any = {};

  // variables a tener en cuenta ara la definición de rangos.
  lsArrayVars: Array<any> = [{ id: 1, strData: 'Peso', observacion: 'Favor relacionar en kilos' }];
  lsVarsSelected: any = {};
  lsRangos: Array<any> | undefined;




  constructor(private config: ConfigService, private flete: FleteService, private message: MessageService) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
  }

  getRangos = () => {
    this.load = true;
    this.flete.getRangoProveedor(this.token.token).subscribe({
      next: (response) => {
        this.lsRangos = response as Array<any>;
        if (this.lsRangos.length == 0) this.message.add({ severity: 'success', detail: 'No hay rangos creados para esta variable' })
        this.load = false;

      },
      error: (error: HttpErrorResponse) => {
        this.load = false;
        this.message.add({ severity: 'success', detail: 'Se ha presentado un error, favor intente nuevamente' })
        this.config.handleError(error)
      }
    })
  }

  setRango = (row: any) => {
    row.message = '';
    if ((row.descripcion != "") && (row.rangoInicial >= 0) && (row.rangoInicial < row.rangoFinal)) {
      const data = {
        "idRangoPesoProveedor": row.idRangoPesoProveedor,
        "descripcion": row.descripcion,
        "variable": this.lsVarsSelected.strData,
        "rangoInicial": row.rangoInicial,
        "rangoFinal": row.rangoFinal
      }
      this.flete.setRangoProveedor(this.token.token, data).subscribe({
        next: (response) => { row.idRangoPesoProveedor = (response as any).idRangoPesoProveedor;
          row.message ="<div class='p-message p-message-success p-3'>Procesamiento exítoso</div>"
         },
        error: (error: HttpErrorResponse) => {
          this.message.add({ severity: 'success', detail: 'Se ha presentado un error, favor intente nuevamente' })
          this.config.handleError(error)
        }
      })

    }
    else
      row.message = "<div class='p-message p-message-warn p-3'>Favor revise la información, todos los campos deben ser diligenciados</div>"
  }

  add = () => {
    (this.lsRangos ?? []).push({
      "idRangoPesoProveedor": 0,
      "descripcion": "",
      "variable": this.lsVarsSelected.strData,
      "rangoInicial": 0,
      "rangoFinal": 0
    })
  }
}
